import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginApi } from "../services/authApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";
import mainContext from "../context/mainContext";

export default function Login({ getBoxListInFirstLoad }) {
  const nav = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [loginInfo, setLoginInfo] = React.useState("");
  const [password, setPassword] = React.useState("");
  const { handleUserType, handleIsAuthed, isAuthed } = useContext(mainContext);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await loginApi({ loginInfo, password, device: "web" });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        handleUserType(resData["data"]["data"][0]["type_user"]);
        handleIsAuthed(true);
        await getBoxListInFirstLoad();
        toast.success("خوش آمدید");
        nav("/home");
      } else {
        toast.error("ورود ناموفق بود");
        handleIsAuthed(false);
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"] || "مشکلی وجود دارد";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (isAuthed) nav("/home");
  }, []);

  return (
    <div className="container" style={{ maxWidth: 440 }}>
      <div style={{ textAlign: "center", margin: "32px 0 24px" }}>
        <img
          src="https://leitnerpwa.umlang.com/icons/logo128.png"
          alt="لایتنر"
          style={{ width: 64, height: 64, borderRadius: 18, marginBottom: 8 }}
        />
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>ورود به لایتنر</h1>
        <p style={{ color: "var(--text-secondary)", fontSize: 13, margin: "4px 0 0" }}>
          با حساب کاربری اوملنگ وارد شوید
        </p>
      </div>
      <div className="card" style={{ padding: 24 }}>
        <form onSubmit={onSubmit}>
          <label className="label">نام کاربری / شماره تلفن / ایمیل</label>
          <input
            className="input"
            value={loginInfo}
            onChange={(e) => setLoginInfo(e.target.value)}
            placeholder="0989123456789"
            required
            autoFocus
          />
          <label className="label" style={{ marginTop: 16 }}>
            رمز عبور
          </label>
          <input
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />
          <button className="btn" disabled={loading} style={{ width: "100%", marginTop: 20 }}>
            {loading ? "...در حال ورود" : "ورود"}
          </button>
        </form>
      </div>
      <div style={{ textAlign: "center", fontSize: 13, color: "var(--text-secondary)", marginTop: 16, lineHeight: 2 }}>
        <p>
          چنانچه قبلا ثبت نام نکرده اید، ابتدا از طریق{" "}
          <a href="https://app.umlang.com/" style={{ color: "var(--primary-light)", fontWeight: 600 }}>
            اپلیکیشن اوملنگ
          </a>{" "}
          یا{" "}
          <a href="https://umlang.com/" style={{ color: "var(--primary-light)", fontWeight: 600 }}>
            وبسایت اوملنگ
          </a>{" "}
          ثبت نام کنید.
        </p>
        <p>
          پس از ثبت نام حتما <strong style={{ color: "var(--accent)" }}>نام کاربری و کلمه عبور</strong> خود را تنظیم کنید.
        </p>
      </div>
      {loading && (
        <div className="center" style={{ marginTop: 16, gap: 8 }}>
          <div className="spinner small"></div>
          <span style={{ color: "var(--text-secondary)" }}>در حال اعتبارسنجی</span>
        </div>
      )}
    </div>
  );
}
